import { Map } from 'immutable';

import { OPERATIONS } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';

import actions from '../../../../actions';

export function vendor({ channel, preview, shopId }) {
  const value = preview.get(ATTRIBUTE.VENDOR);
  const index = preview.get('index');
  const payload = Map({ type: OPERATIONS[channel].VENDOR, value: value || '' });
  const actionsToDispatch = [];

  if (value && index === -1) {
    actionsToDispatch.push(actions.data.addVendor({ shopId, vendor: value }));
  }

  return { actions: actionsToDispatch, payload };
}
